<template>
    <div class="d-flex flex-column vh-100">
        <NavigationBar></NavigationBar>
        <div class="d-flex flex-grow-1">
            <div class="card w-100">
                <b-tabs card class="h-100">
                    <b-tab title="Declaraciones" active class="p-0">
                        <StatementsMenu></StatementsMenu>
                        <StatementsFilter></StatementsFilter>
                        <StatementDocument></StatementDocument>
                        <StatementsList></StatementsList>
                        <FooterView></FooterView>
                    </b-tab>
                    <b-tab title="PEP" lazy class="p-0">
                        <PepStatementsMenu></PepStatementsMenu>
                        <PepStatementsFilter></PepStatementsFilter>
                        <PepStatementDocument></PepStatementDocument>
                        <PepStatementsList></PepStatementsList>
                        <FooterView></FooterView>
                    </b-tab>
                    <b-tab title="Familiares" lazy class="p-0">
                        <FamilyStatementsMenu></FamilyStatementsMenu>
                        <FamilyStatementsFilter></FamilyStatementsFilter>
                        <FamilyStatementDocument></FamilyStatementDocument>
                        <FamilyStatementsList></FamilyStatementsList>
                        <FooterView></FooterView>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import NavigationBar from '@/components/shared/Navigation-bar.vue';
import FooterView from '@/components/shared/Footer/Footer-view.vue';

import StatementsMenu from "@/components/Statements/Statements-menu.vue";
import StatementsList from '@/components/Statements/Statements-list.vue';
import StatementsFilter from '@/components/Statements/Statements-filter.vue';
import StatementDocument from "@/components/Statements/StatementsList/Statement-document.vue";

import PepStatementsMenu from '@/components/PepStatements/Pep-statements-menu.vue';
import PepStatementsFilter from '@/components/PepStatements/Pep-statements-filter.vue';
import PepStatementsList from '@/components/PepStatements/Pep-statements-list.vue';
import PepStatementDocument from '@/components/PepStatements/PepStatementsList/Pep-statement-document.vue';

import FamilyStatementsMenu from '@/components/FamilyStatements/Family-statements-menu.vue';
import FamilyStatementsList from '@/components/FamilyStatements/Family-statements-list.vue';
import FamilyStatementDocument from '@/components/FamilyStatements/FamilyStatementsList/Family-statement-document.vue';
import FamilyStatementsFilter from '@/components/FamilyStatements/Family-statements-filter.vue';

export default {
    name: 'StatementsViews',

    components:{
        NavigationBar,
        FooterView,
        StatementsMenu,
        StatementsList,
        StatementsFilter,
        StatementDocument,
        PepStatementsMenu,
        PepStatementsFilter,
        PepStatementsList,
        PepStatementDocument,
        FamilyStatementsMenu,
        FamilyStatementsList,
        FamilyStatementsFilter,
        FamilyStatementDocument,
    },
}
</script>

<style scoped>
.card {
  overflow-y: auto;
}
</style>